import React from 'react';
import styled from 'styled-components';
import SuperAdminActiveJobs from 'Components/SuperAdminPage/SuperAdminActiveJobs';
import { SuperAdminLayout } from 'Components/Layout/SuperAdminLayout';

const ContentContainer = styled.div`
  width: 100%;
  margin: 20px;
  overflow: auto;
  flex: 1;
`;

const AdminPanel = () => {
  return (
    <SuperAdminLayout>
      <ContentContainer>
        <SuperAdminActiveJobs />
      </ContentContainer>
    </SuperAdminLayout>
  );
};
export default AdminPanel;
